import { color, size, effects as foundationEffects } from "../foundation";
import { effects } from "./effects";

export const state = {
  opacity: {
    disabled: foundationEffects.opacity[60],  // disabled button and input statues
  },
  outline: {
    color: {
      focus: color.primary[700],  // focus state outline for buttons, form fields, etc.
    },
    weight: {
      focus: {
        sm: effects.border.sm,  // focus state outline weight for links and inputs
        md: effects.border.md,  // focus state outline weight for buttons
      }
    },
    offset: {
      focus: {
        sm: size[25], 
        md: size[50],  // focus state outline offset default
      },
    },
    radius: {
      focus: effects.radius.sm,
    },
  },
}

export default state;